export default dateOfBirth => `* ${dateOfBirth.split('-').reverse().join('.')}`;
